import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { SET_CARD_ATTACHMENT_MUTATION } from '../../schema/mutations/setCardAttachment';

export function useSetCardAttachmentMutation(options?: MutationHookOptions) {
  return useMutation(SET_CARD_ATTACHMENT_MUTATION, options);
}
